import {Component, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'dmp-set-null-editor',
    templateUrl: './set-null-editor.component.html',
    styleUrls: ['./set-null-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SetNullEditorComponent
        }
    ],
    standalone: false
})
export class SetNullEditorComponent implements ControlValueAccessor {
    valueBoolean = true;
    @Input() disabled = false;
    touched = false;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = (value) => {
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onTouched = () => {
    }
    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }
    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    writeValue(isNotNull: boolean): void {
        this.valueBoolean = isNotNull;
    }

    valueChange() {
        this.onChange(this.valueBoolean);
        this.markAsTouched();
    }
}
